var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28.0003,
    height: 28,
    viewBox: "0 0 28.0003 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4506",
    d: "M24.6668 0.25H27.7498V7.75H24.6668C23.7003 7.74999 22.9168 6.96649 22.9168 6V2C22.9168 1.03351 23.7003 0.250013 24.6668 0.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4507",
    d: "M24.667 10.25H27.75V17.75H24.667C23.7005 17.75 22.917 16.9665 22.917 16V12C22.917 11.0335 23.7005 10.25 24.667 10.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4508",
    d: "M24.6668 20.25H27.7498V27.75H24.6668C23.7003 27.7499 22.9168 26.9664 22.9168 26V22C22.9168 21.0335 23.7003 20.25 24.6668 20.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M16.3335 4C15.8335 4 13.8335 4 13.8335 4V14M13.8335 14V24H16.3335M13.8335 14H16.3335",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 926",
    cx: 17.9984,
    cy: 4.00008,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 927",
    cx: 17.9984,
    cy: 13.9999,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 929",
    cx: 2,
    cy: 13.9999,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 928",
    cx: 17.9984,
    cy: 24,
    r: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M13.8335 14H11.0002",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M6.33333 14H3.5",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4509",
    d: "M7.99951 10.25H11.0825V17.75H7.99951C7.03302 17.75 6.24953 16.9665 6.24951 16V12C6.24953 11.0335 7.03302 10.25 7.99951 10.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.500006
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemDesign);
export default __webpack_public_path__ + "static/media/systemDesign.b14147949aefbb5b1094ea68a6cea8e2.svg";
export { ForwardRef as ReactComponent };